import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  input,
  contentChild,
  viewChild,
  computed,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { OverlayPosition, OverlayRole } from '../fc-overlay/overlay.types';
import { OverlayService } from '../fc-overlay/overlay.service';
import { ButtonComponent } from '@fc-shared/ui/buttons/button.component';
import { OverlayClickDirective } from '../fc-overlay/overlay-click.directive';
import { MenuContentComponent } from './menu-content.component';

@Component({
  selector: 'fc-menu',
  template: `
    <ng-content select="[fcOverlayClick]" />
    @if (!customTrigger()) {
      <fc-button
        variant="icon"
        #defaultTrigger="fcOverlayClick"
        fcOverlayClick
        icon="icon-more"
      />
    }
    <fc-menu-content
      [target]="activeTrigger()"
      [position]="position()"
      [role]="role()"
    >
      <ng-content></ng-content>
    </fc-menu-content>
  `,
  imports: [ButtonComponent, OverlayClickDirective, MenuContentComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '(click)': '$event.stopPropagation()',
    '(keydown.enter)': '$event.stopPropagation()',
    '(keydown.space)': '$event.stopPropagation()',
  },
})
export class MenuComponent implements AfterViewInit, OnDestroy {
  private elementRef = inject(ElementRef<HTMLElement>);
  private overlayService = inject(OverlayService);
  private registeredOverlayId?: string;

  customTrigger = contentChild(OverlayClickDirective);
  defaultTrigger = viewChild('defaultTrigger', { read: OverlayClickDirective });

  target = input<any>();
  position = input<OverlayPosition>('bottom-right');
  role = input<OverlayRole>('menu');

  activeTrigger = computed(
    () => this.target() || this.customTrigger() || this.defaultTrigger(),
  );

  ngAfterViewInit(): void {
    const trigger = this.target();
    if (!trigger) return;

    const overlayId = trigger.overlayId;
    if (!overlayId) return;

    const element = this.elementRef.nativeElement;
    element.id = overlayId;
    element.style.positionAnchor = `--${overlayId}`;
    this.overlayService.register(overlayId, element);
    this.registeredOverlayId = overlayId;
  }

  ngOnDestroy(): void {
    if (this.registeredOverlayId) {
      this.overlayService.unregister(this.registeredOverlayId);
    }
  }
}
